import React from "react";
import "../style/whatsapp.css";

const WhatsAppButton = ({ mobile }) => {
  const defaultPhone = "+963931451710";
  let phone = mobile || defaultPhone;
  
  if (!phone.startsWith("+963")) {
    phone = phone.replace(/\D/g, "");

    if (phone.startsWith("0")) {
      phone = phone.substring(1); 
    }

    phone = "+963" + phone;
  }

  const message = "مرحباً، أحتاج إلى مساعدة 😄";
  const whatsappLink = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappLink}
      className="whatsapp-fab"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        src="https://cdn-icons-png.flaticon.com/512/124/124034.png"
        alt="WhatsApp"
      />
    </a>
  );
};

export default WhatsAppButton;
